import { render, staticRenderFns } from "./progress-bar.vue?vue&type=template&id=50527234&scoped=true"
import script from "./progress-bar.vue?vue&type=script&lang=js"
export * from "./progress-bar.vue?vue&type=script&lang=js"
import style0 from "./progress-bar.vue?vue&type=style&index=0&id=50527234&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50527234",
  null
  
)

export default component.exports